import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const ProfileIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            d="M19.0781 20.0132V18.2632C19.0781 16.3302 17.5111 14.7632 15.5781 14.7632H8.57812C6.64513 14.7632 5.07812 16.3302 5.07812 18.2632V20.0132"
            stroke={iconColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0781 11.2632C14.0111 11.2632 15.5781 9.69618 15.5781 7.76318C15.5781 5.83019 14.0111 4.26318 12.0781 4.26318C10.1451 4.26318 8.57812 5.83019 8.57812 7.76318C8.57812 9.69618 10.1451 11.2632 12.0781 11.2632Z"
            stroke={iconColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export { ProfileIcon };